import LineInterface from 'app/interfaces/LineInterface';
import {isAdvantageLine} from 'app/lines/isAdvantageLine';
import {userStore} from 'app/store/global';

export type GamerType = {
    nick: string
    nick_langs?: Record<string, string>
    nick_quick: string
    flag: string
    race: string
    type: string
    game_name: string
    photo: {
        src: string
        type_on: boolean
    }
};

export const lineGamer = (line: LineInterface, gamerNum: number): GamerType => {
    const res = isAdvantageLine(line) ? line.parent : line;
    const gamer = res[`gamer_${isAdvantageLine(line) ? line.gamer : gamerNum}`];

    if (gamer) {
        return gamer;
    }

    if (line.parent) {
        return line.parent[`gamer_${gamerNum}`];
    }

    if (userStore.user.experimental_features) {
        console.log('lineGamer error: gamer is undefined and no parent fallback', {gamerNum, line});
    }

    return gamer;
};
